export default __webpack_public_path__ + "static/media/product-9.24d3cc9f.jpg";